<template>
    <v-slider :readonly="readonly" class="mt-12 mb-6" ticks="always" tick-size="5" min="0" max="5" :tick-labels="['Keine Angabe',1,2,3,4,5]" thumb-label="always" thumb-color="secondary"
              v-model="inputVal"
    > </v-slider>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        props: ['readonly', 'value'],
        name: "",
        data: () => ({}),
        methods: {
            ...mapActions({}),

        },
        computed: {
            inputVal: {
                get (){
                    return this.value;
                },
                set (val){
                    this.$emit('input', val)
                }
            }
        }
    }
</script>

<style scoped>

</style>